import React from 'react';
import { TableRow, TableCell, Select } from '@material-ui/core';
import { EditTeamUsers } from 'redux/models/editTeamUsers';
import './TeamUserRow.scss';

interface TeamUserRowProps {
	index: number;
	teamUser: EditTeamUsers;
	disabled: boolean;
	userId: string;
	onChange: (event: any) => void;
	removeUser: (teamUser: EditTeamUsers, deleted: boolean) => void;
}

const TeamUserRow: React.FC<TeamUserRowProps> = (props: TeamUserRowProps) => {
	const { index, teamUser, disabled, userId, onChange, removeUser } = props;
	const rowDisabled = teamUser.isDeleted || disabled || userId === teamUser.userId ? true : false;
	const actionsHidden = disabled || userId === teamUser.userId ? true : false;
	const userRole = teamUser.isAdmin ? 'Administrator' : 'Member'

	return (
		<TableRow className={`team-user ${rowDisabled ? 'team-user--disabled' : 'team-user--enabled'}`}>
			<TableCell scope='row' align='left' className='team-user__item'>
				{teamUser.userName}
			</TableCell>
			<TableCell scope='row' align='left' className='team-user__item'>
				{teamUser.userEmail || 'N/A'}
			</TableCell>
			<TableCell align='left' className='team-user__item'>
				{actionsHidden ? (
					<div>{userRole}</div>
				) : (
					<Select
						native
						disabled={teamUser.isDeleted}
						value={userRole}
						onChange={event => onChange(event)}
						inputProps={{
							id: `${index}`,
						}}
					>
						<option value='Member'>Member</option>
						<option value='Administrator'>Administrator</option>
					</Select>
				)}
			</TableCell>
			{!actionsHidden && (
				<TableCell align='left' className='team-user__item'>
					{teamUser.isDeleted ? (
						<span onClick={() => removeUser(teamUser, false)} className='team-user__item--remove'>
							Undo remove
						</span>
					) : (
						<span onClick={() => removeUser(teamUser, true)} className='team-user__item--remove'>
							Remove Member
						</span>
					)}
				</TableCell>
			)}
			{
				actionsHidden && !disabled && <TableCell align='left' className='team-user__item'></TableCell>
			}
		</TableRow>
	);
};

function areEqual(prevProps: TeamUserRowProps, nextProps: TeamUserRowProps) {
	const prevTeamUser = prevProps.teamUser;
	const nextTeamUser = nextProps.teamUser;
	const adminDiff = prevTeamUser.isAdmin === nextTeamUser.isAdmin;
	const userIdDiff = prevTeamUser.userId === nextTeamUser.userId;
	const deletedDiff = prevTeamUser.isDeleted === nextTeamUser.isDeleted;

	if (adminDiff && userIdDiff && deletedDiff) {
		return true;
	} else {
		return false;
	}
}

export default React.memo(TeamUserRow, areEqual);
